<template>
  <!--
      	作者：luoyiming
      	时间：2019-06-04
      	描述：插件中心-优惠券-领取记录
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="订单ID">
          <el-input v-model="formInline.order_id" placeholder="请输入订单ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @cell-click="gotoOrderDetail">
        <el-table-column prop="user.user_id" label="用户ID"></el-table-column>
        <el-table-column prop="user.nickName" label="用户">
          <template slot-scope="scope">
            {{ scope.row.user ? scope.row.user.nickName : '无主' }}
          </template>
        </el-table-column>
        <el-table-column prop="coupon_id" label="优惠券ID"></el-table-column>
        <el-table-column prop="order_id" label="订单ID"></el-table-column>
        <el-table-column prop="originCoupon.name" label="优惠券名称"></el-table-column>
        <el-table-column prop="originCoupon.coupon_type.text" label="优惠券类型"></el-table-column>
        <el-table-column prop="used_num" label="使用数量"></el-table-column>
        <el-table-column prop="use_desc" label="描述"></el-table-column>
        <el-table-column prop="userCoupon.is_using" label="是否使用">
          <template slot-scope="scope">
            <div v-if="scope.row.userCoupon.is_using==0">
              <span>未使用</span>
            </div>
            <div v-if="scope.row.userCoupon.is_using==1">
              <span>使用中</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="兑换时间"></el-table-column>
      </el-table>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="formInline.page" :page-size="formInline.list_rows" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import CouponApi from '@/api/coupon.js';
import qs from 'qs';

export default {
  data() {
    return {
      formInline: {
        user_id: '',
        order_id: '',
        list_rows: 20,
        page: 1,
      },
      tableData: [],
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*是否加载完成*/
      loading: true,
      // is_use:['未使用','已使用'],
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*获取列表*/
    getData() {
      let self = this;
      CouponApi.getPickUpCouponUsedLog(self.formInline, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total
        })
        .catch(error => {});
    },
    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      self.getData();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.formInline.page = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.formInline.page = 1;
      this.getTableList();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/plus.coupon.coupon/export?' + qs.stringify(this.formInline);
    },
    gotoOrderDetail(row, column) {
      if (column.property === 'order_id') {
        let order_id = row.order_id
        let routeUrl = this.$router.resolve({
          path: '/order/order/Detail',
          query: {order_id}
        })
        window.open(routeUrl.href, '_blank')
      }
    },
  }
};
</script>

<style lang="sass" scoped></style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/CouponUsedLog.vue